import { Component, OnInit } from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {UserService} from "../../services/user.service";
import {MdbModalRef, MdbModalService} from "mdb-angular-ui-kit/modal";
import {Router} from "@angular/router";
import {AppConfigService} from "../../services/config/app-config.service";
import {TokenStorageService} from "../../services/storage/token-storage.service";
import {MdbTabChange} from "mdb-angular-ui-kit/tabs/tabs.component";
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-configurations-page',
    templateUrl: './configurations-page.component.html',
    styleUrls: ['./configurations-page.component.css'],
    standalone: false
})
export class ConfigurationsPageComponent implements OnInit {
  loading: boolean = false;
  instDetaislsModalRef: MdbModalRef<InstDetailsModalComponent> | any;
  instResponse: any;
  instDetailsResponse: any;
  pa: number = 1;

  itemsPerPage: number = 10;
  initialLoading: boolean = false;
  filterText = '';
  selectedFilter = 'institutionName';
  filters = [
    { name: 'ID', value: 'institutionId' },
    { name: 'Code', value: 'institutionCode' },
    { name: 'Name', value: 'institutionName' },
    { name: 'Tel', value: 'officeTel' },
    { name: 'Email', value: 'email' },
  ];
  instData: any;
  instDetails: any;
  isUsersShow: boolean = true;
  sortOrder = "ascending";
  sortBy = "";

  showAdminComponents: boolean = false;
  showBrokerComponents: boolean = false;
  showBrokerAdminComponents:boolean=false;
  user: any;
  isLoggedIn: boolean = false;
  inst :any;
  env:any;


  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private userService: UserService,
              private appConfig: AppConfigService,
              private toastr: ToastrService,
              private modalService: MdbModalService,
              private tokenStorageService: TokenStorageService,
              private cdr: ChangeDetectorRef,
              private tokenStorage: TokenStorageService
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();

      this.showAdminComponents = this.user.role == 'admin';
      this.showBrokerComponents = this.user.role == 'broker';
      this.showBrokerAdminComponents = this.user.role =='brokerAdmin';
      this.env = this.showAdminComponents ? 'asia' : this.tokenStorage.getUserEnv();
    }

    if(this.showAdminComponents){
      this.institutionList(this.pa, '', '', "", "");
    }
    else if(this.showBrokerComponents || this.showBrokerAdminComponents){
      this.institutionDetails();

    }
  }

  openInstDetailsModalGeneric(institution: any, component: any) {
    this.instDetaislsModalRef = this.modalService.open(component, {
      modalClass: 'modal-dialog modal-dialog-centered modal-xl',
      data: {
        id: institution.institutionId,
        code: institution.institutionCode,
        name: institution.institutionName,
        masterAccountNumber: institution.masterAccountNumber,
        publicKey: institution.publicKey,
        appKey: institution.appKey,
        appSecret: institution.appSecret,
        openApiEnabled: institution?.openApiEnabled,
        fixEnabled: institution?.fixEnabled,
        boApisEnabled: institution?.boApisEnabled,
        dwmApiEnabled: institution?.dwmApiEnabled,
        depositAutoApproval: institution?.depositAutoApproval,
        withdrawAutoApproval: institution?.withdrawAutoApproval,
      },
    });

    this.instDetaislsModalRef.onClose.subscribe((message: any) => { });
  }


  openInstDetailsModal(institution: any) {
    this.openInstDetailsModalGeneric(institution, InstDetailsModalComponent);
  }

  toggleSortDirection() {
    this.sortOrder = this.sortOrder === 'ascending' ? 'descending' : 'ascending';
    return this.sortOrder;
  }

  institutionList(pageNo: number, filter: string, filterText: string, sortOrder: string, sortBy: string) {
    this.loading = true;
    // this.cdr.detectChanges();

    this.userService.getInstitutionListPagination(pageNo, this.itemsPerPage, sortOrder, sortBy, filter, filterText).subscribe(
      {
        next: (data) => {
          this.loading = false;
          this.cdr.detectChanges();

          if (data.status === 'SUCCESS') {
              this.instResponse = data;
              this.instData = this.initInstData(data);


            if (this.instResponse?.list?.length <= 0) {
              this.isUsersShow = false;
            }
          } else {
            this.toastr.error(data.reason, "Failed to load data");
          }
        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, "Failed to load data");
        }
      }
    );
  }

  initInstData(data: any) {
    return data?.institutionList?.map((elemen: any) => ({
      institutionId: elemen?.m05BranchId,
      institutionCode: elemen?.m05BranchCode,
      institutionName: elemen?.m05BranchName,
      masterAccountNumber: elemen?.m05MasterAccount,
      officeTel: elemen?.m05Telephone,
      email: elemen?.m05Email,
      publicKey: elemen?.m05PublicKey,
      appKey: elemen?.m05AppKey,
      appSecret: elemen?.appSecret,
      openApiEnabled: elemen?.m05GtnOpenApiEnabled,
      embedApiEnabled: elemen?.m05EmbedApiEnabled,
      boApisEnabled: elemen?.m05BoApiEnabled,
      dwmApiEnabled: elemen?.m05DwmApiEnabled,
      depositAutoApproval: elemen?.m05DepositAutoApproval,
      withdrawAutoApproval: elemen?.m05AllowWthdrwAutoApproval,
    })) || [];
  }


institutionDetails() {
    this.loading = true;
    this.userService.getInstitutionDetails(this.tokenStorageService.getUser().institution).subscribe(
      {
        next: (data) => {
          this.loading = false;
          if (data.status == 'SUCCESS') {

            this.inst = data;

            this.instDetails = this.initInstDetails(data)
            this.instDetailsResponse = data;

              if(this.inst && this.inst.list && this.inst.list.length <= 0){
                this.isUsersShow = false;
            }
          } else {

            this.toastr.error(data.reason, "Failed to load data");
          }

        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, "Failed to load data");
        }
      }
    );

  }

  initInstDetails(data: any) {
    var tempData: any = [];
      var temp = {
        institutionId: data?.institution?.institutionId,
        institutionCode: data?.institution?.institutionCode,
        institutionName: data?.institution?.institution,
        masterAccountNumber: data?.institution?.masterAccountNumber,
        officeTel: data?.institution?.officeTel,
        email: data?.institution?.email,
        publicKey:data?.institution?.publicKey,
        appKey: data?.institution?.appKey,
        appSecret: data?.institution?.appSecret,
        openApiEnabled: data?.institution?.openApiEnabled,
        fixEnabled: data?.institution?.fixEnabled,
        boApisEnabled: data?.institution?.boApisEnabled,
        dwmApiEnabled: data?.institution?.dwmApiEnabled,
        depositAutoApproval: data?.institution?.depositAutoApproval,
        withdrawAutoApproval: data?.institution?.withdrawAutoApproval,
      };
      tempData.push(temp);

    return tempData;
  }


  pageChanged(event: any): void {
    this.pa = event;
    this.institutionList(this.pa,  this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);
  }

  pageSizeChanged(entries: number): void {
    this.itemsPerPage = entries;
    this.institutionList(this.pa,  this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);
  }



  getInstitutionList(event: MdbTabChange) {
    if (event.index === 0) {
        this.institutionList(this.pa, '', '', "", "");
    }
    else if (event.index === 1) {
        this.institutionList(this.pa, '', '', "", "");
      }
    }

}

@Component({
    selector: 'inst-details-modal:not(p)',
    templateUrl: './inst-details-modal.html',
    styleUrls: ['./configurations-page.component.css'],
    standalone: false
})
export class InstDetailsModalComponent {
  all: String = "*";
  id: any;
  loading: boolean = false;
  name: any;
  code: any;
  publicKey : any;
  appKey : any;
  appSecret : any;
  masterAccountNumber: any;
  openApiEnabled : any;
  fixEnabled : any;
  boApisEnabled : any;
  dwmApiEnabled : any;
  depositAutoApproval : any;
  withdrawAutoApproval : any;
  loadingBankAcc: boolean = false;
  loadingBank: boolean = false;
  isTableEmptyBank: boolean = false;
  isTableEmptyBankAcc: boolean = false;

  isTableEmpty: boolean = false;
  isKeyEmpty: boolean = false;
  instBankList: any;
  topic :String = "General";

  customerDetails: any;
  bankDetails: any;
  loadingCustomerProfile: boolean = false;

  form: FormGroup = new FormGroup({
    publicKey: new FormControl(''),
    appKey: new FormControl(''),
    appSecret: new FormControl(''),
    masterAcc: new FormControl(''),
  });
  instCustomerProfile: any;
  isTableEmptyProfile: boolean = false;
  selectedUserIndex: number = -1;
  customerDetailsCP: any;
  isTableEmptyCP: boolean = false;
  customerName: any;
  selectedUserIndexSP: number = -1;
  loadingSubscriptionPackage: boolean = false;
  isTableEmptyPackage: boolean = false;
  instSubscriptionPackages: any;
  subsPackages: any;
  loadingCP: boolean = false;
  isSelectRowCP: boolean = false;
  isSelectRowSP: boolean = false;
  packageName: any;
  loadingExchanges: boolean = false;
  isTableEmptyExchange: boolean = false;
  Exchanges: any;
  element:any
  defaultSubsPckgCount:number=0;
  noDefaultSubsPckgs: boolean = false;

  defaultCustProfilesCount:number=0;
  noDefaultCustProfiles: boolean = false;

  isNoCashAccounts: boolean = false;
  isNoSecurityAccounts: boolean = false;
  isNoExchangeAccounts: boolean = false;
  cashAccCount:number=0;
  securityAccCount:number=0;
  exchangeAccCount:number=0;
  env:any;


  constructor(
    public modalRef: MdbModalRef<InstDetailsModalComponent>,
    private toastr: ToastrService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit(): void {
    this.getSelectedInst();
    this.initializeForm();
    this.env = this.tokenStorage.getUserEnv();
  }
  getSelectedInst() {
    if(this.masterAccountNumber== null || this.masterAccountNumber== ''){
      //this.isTableEmpty = true;
      this.isNoCashAccounts = true;
      this.isNoSecurityAccounts= true;
      this.isNoExchangeAccounts = true;
    }

    if (
      this.masterAccountNumber != null ||
      this.masterAccountNumber != ''
    ) {
      this.userService
        .getCustomerAccountDetails(this.masterAccountNumber, this.env)
        .subscribe((data1: any) => {

          if (data1.status == 'SUCCESS') {
            if (data1.cashAccounts.length) {
              this.isTableEmpty = false;
            } else {
              this.isTableEmpty = true;
            }

            this.customerDetails = data1;

            if(data1.cashAccounts.length==0){
              this.isNoCashAccounts=true;
            }
            data1.cashAccounts.forEach((cashAccount: { securityAccounts: any[]; }) => {
              if (cashAccount.securityAccounts && cashAccount.securityAccounts.length>0) {
                this.securityAccCount += cashAccount.securityAccounts.length;

                cashAccount.securityAccounts.forEach(securityAccount => {
                  if (securityAccount.exchangeAccounts && securityAccount.exchangeAccounts.length>0) {
                    this.exchangeAccCount += securityAccount.exchangeAccounts.length;
                  }
                });
              }

            });

            if(this.securityAccCount == 0){
              this.isNoSecurityAccounts=true;
            }

            if(this.exchangeAccCount == 0){
              this.isNoExchangeAccounts=true;
            }
          } else {
          //  this.isTableEmpty = true;
            this.isNoCashAccounts = true;
            this.isNoSecurityAccounts= true;
            this.isNoExchangeAccounts = true;
          }
        });
    } else {
      //this.isTableEmpty = true;
      this.isNoCashAccounts = true;
      this.isNoSecurityAccounts= true;
      this.isNoExchangeAccounts = true;
    }
    this.userService.getInstExchangesList(this.code, this.env).subscribe((dataE: any) => {
      this.isTableEmptyExchange = false;

      if (dataE.status == 'SUCCESS') {
        this.Exchanges = dataE;

        if (
          this.Exchanges.list == null ||
          this.Exchanges.list.length == 0
        ) {
          this.isTableEmptyExchange = true;
        }
      } else {
        this.isTableEmptyExchange = true;
      }
    });


    this.userService.getBankAccountDetails(this.code , "", this.env).subscribe((data2: any) => {
      this.isTableEmptyBankAcc = false;

      if (data2.status == 'SUCCESS') {
        this.bankDetails = data2;

        if (
          this.bankDetails.bankAccountList == null ||
          this.bankDetails.bankAccountList.length == 0
        ) {
          this.isTableEmptyBankAcc = true;
        }
      } else {
        this.isTableEmptyBankAcc = true;
      }
    });

    this.userService.getInstBankList(this.code, this.env).subscribe((data3: any) => {
      this.isTableEmptyBank = false;

      if (data3.status == 'SUCCESS') {
        this.instBankList = data3;

        if (
          this.instBankList.bankList == null ||
          this.instBankList.bankList.length == 0
        ) {
          this.isTableEmptyBank = true;
        }
      } else {
        this.isTableEmptyBank = true;
      }
    });

    this.userService.getInstCustomerProfile(this.code, this.env).subscribe((data4: any) => {
      console.log('Received data:', data4);
      this.isTableEmptyProfile = false;

      if (data4.status == 'SUCCESS') {
        this.instCustomerProfile = data4;
        console.log("instCustomerProfile: ", this.instCustomerProfile)

        if (
          this.instCustomerProfile.profileList == null ||
          this.instCustomerProfile.profileList.length == 0
        ) {
          console.log("is table empty: ", this.isTableEmptyProfile)
          this.isTableEmptyProfile = true;
        }

        this.instCustomerProfile.profileList.forEach((element: any)=>{
          if(element.isDefault==="YES"){
            this.defaultCustProfilesCount+=1;
          }
        })

        if(this.defaultCustProfilesCount==0){
          console.log("is default profile exist: ", this.noDefaultCustProfiles)

          this.noDefaultCustProfiles=true;
        }

      } else {
        this.isTableEmptyProfile = true;
      }
    });

    this.userService.getInstSubscriptionPackageList(this.code, this.env).subscribe((data5: any) => {
      this.isTableEmptyPackage = false;

      if (data5.status == 'SUCCESS') {
        this.instSubscriptionPackages = data5;

        if (
          this.instSubscriptionPackages.packageList == null ||
          this.instSubscriptionPackages.packageList.length == 0
        ) {
          this.isTableEmptyPackage = true;
        }

        this.instSubscriptionPackages.packageList.forEach((element: any)=>{
          if(element.isDefault==="YES"){
            this.defaultSubsPckgCount+=1;
          }
        })

        if(this.defaultSubsPckgCount==0){
          this.noDefaultSubsPckgs=true;
        }

      } else {
        this.isTableEmptyPackage = true;
      }
    });

  }


  selectedRowCP($event:any, customerNumber:any, userInded: number, customerName:any){
    if(userInded === this.selectedUserIndex) {
      this.selectedUserIndex = -1;
      return;
    }
    this.customerName = customerName;
    this.selectedUserIndex = userInded;
    this.isSelectRowCP = true

    this.userService
      .getCustomerDetails(customerNumber, this.env)
      .subscribe((data1: any) => {

        if (data1.status == 'SUCCESS') {
          if (data1.cashAccounts.length) {
            this.isTableEmptyCP = false;
          } else {
            this.isTableEmptyCP = true;
          }
          this.customerDetailsCP = data1;
        } else {
          this.isTableEmptyCP = true;
        }
      });
  }

  selectedRowSP($event:any, subsPackages:any, userIndedSP: number){
    if(userIndedSP === this.selectedUserIndexSP) {
      this.selectedUserIndexSP = -1;
      return;
    }
    this.packageName = subsPackages.packageName;
    this.selectedUserIndexSP = userIndedSP;
    this.subsPackages = subsPackages;
    this.isSelectRowSP = true

    if(subsPackages.exchangeList.length)
    {
      this.isTableEmpty = false;
    }else{
      this.isTableEmpty = true;
    }
  }


  initializeForm(): void {

    this.form = this.formBuilder.group({
      publicKey: [this.publicKey ? this.publicKey : "-", [Validators.required]],
      appKey: [this.appKey ? this.appKey : "-", [Validators.required]],
      appSecret: [this.appSecret ? "***********" : "-", [Validators.required]],
      openApiEnabled: [this.openApiEnabled, [Validators.required]],
      fixEnabled: [this.fixEnabled, [Validators.required]],
      boApisEnabled: [this.boApisEnabled, [Validators.required]],
      dwmApiEnabled: [this.dwmApiEnabled, [Validators.required]],
      depositAutoApproval: [this.depositAutoApproval, [Validators.required]],
      withdrawAutoApproval: [this.withdrawAutoApproval, [Validators.required]],
    });
  }



  get formControl(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  onButtonGroupClick($event: any) {
    let clickedElement = $event.target || $event.srcElement;


    if (clickedElement.nodeName === 'BUTTON') {
      let isCertainButtonAlreadyActive =
        clickedElement.parentElement.querySelector('.active');

      if (isCertainButtonAlreadyActive) {
        isCertainButtonAlreadyActive.classList.remove('active');
      }
      this.topic = $event.target.role;

      if ($event.target.id == 'general') {
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.key-container-content'))).className += ' active';
        (<HTMLElement>(document.querySelector('.key-container-content'))).className += ' show';
      } else if ($event.target.id == 'masterAcc') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.masterAcc-content')).className +=' active';
        (<HTMLElement>document.querySelector('.masterAcc-content')).className +=' show';
      } else if ($event.target.id == 'bankAcc') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.bankAcc-content')).className +=' active';
        (<HTMLElement>document.querySelector('.bankAcc-content')).className +=' show';
      } else if ($event.target.id == 'banks') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.bank-content')).className +=' active';
        (<HTMLElement>document.querySelector('.bank-content')).className +=' show';
      } else if ($event.target.id == 'customer') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.customer-content')).className +=' active';
        (<HTMLElement>document.querySelector('.customer-content')).className +=' show';
      } else if ($event.target.id == 'subscription') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.subscription-content')).className +=' active';
        (<HTMLElement>document.querySelector('.subscription-content')).className +=' show';
      }else if ($event.target.id == 'exchanges') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.exchange-content')).className +=' active';
        (<HTMLElement>document.querySelector('.exchange-content')).className +=' show';
      }

      clickedElement.className += ' active';
    }
  }

  closeModal(): void {
    this.modalRef.close();
  }

}

@Component({
    selector: 'inst-details-modal',
    templateUrl: './inst-details-modal.html',
    styleUrls: ['./configurations-page.component.css'],
    standalone: false
})
export class InstDetailsModalDIFCComponent {
  all: String = "*";
  id: any;
  loading: boolean = false;
  name: any;
  code: any;
  publicKey : any;
  appKey : any;
  appSecret : any;
  masterAccountNumber: any;
  openApiEnabled : any;
  fixEnabled : any;
  boApisEnabled : any;
  dwmApiEnabled : any;
  depositAutoApproval : any;
  withdrawAutoApproval : any;
  loadingBankAcc: boolean = false;
  loadingBank: boolean = false;
  isTableEmptyBank: boolean = false;
  isTableEmpty: boolean = false;
  isKeyEmpty: boolean = false;
  instBankList: any;
  topic :String = "General";
  isTableEmptyBankAcc: boolean = false;


  customerDetails: any;
  bankDetails: any;
  loadingCustomerProfile: boolean = false;

  form: FormGroup = new FormGroup({
    publicKey: new FormControl(''),
    appKey: new FormControl(''),
    appSecret: new FormControl(''),
    masterAcc: new FormControl(''),
  });
  instCustomerProfile: any;
  isTableEmptyProfile: boolean = false;
  selectedUserIndex: number = -1;
  customerDetailsCP: any;
  isTableEmptyCP: boolean = false;
  customerName: any;
  selectedUserIndexSP: number = -1;
  loadingSubscriptionPackage: boolean = false;
  isTableEmptyPackage: boolean = false;
  instSubscriptionPackages: any;
  subsPackages: any;
  loadingCP: boolean = false;
  isSelectRowCP: boolean = false;
  isSelectRowSP: boolean = false;
  packageName: any;
  loadingExchanges: boolean = false;
  isTableEmptyExchange: boolean = false;
  Exchanges: any;

  element:any
  defaultSubsPckgCount:number=0;
  noDefaultSubsPckgs: boolean = false;

  defaultCustProfilesCount:number=0;
  noDefaultCustProfiles: boolean = false;

  isNoCashAccounts: boolean = false;
  isNoSecurityAccounts: boolean = false;
  isNoExchangeAccounts: boolean = false;
  cashAccCount:number=0;
  securityAccCount:number=0;
  exchangeAccCount:number=0;
  env:any;



  constructor(
    public modalRef: MdbModalRef<InstDetailsModalDIFCComponent>,
    private toastr: ToastrService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit(): void {
    this.getSelectedInst();
    this.initializeForm();
    this.env = this.tokenStorage.getUserEnv();
  }
  getSelectedInst() {
    if(this.masterAccountNumber== null || this.masterAccountNumber== ''){
      //this.isTableEmpty = true;
      this.isNoCashAccounts = true;
      this.isNoSecurityAccounts= true;
      this.isNoExchangeAccounts = true;
    }

    if (
      this.masterAccountNumber != null ||
      this.masterAccountNumber != ''
    ) {
      this.userService
        .getCustomerAccountDetails(this.masterAccountNumber, 'mena')
        .subscribe((data1: any) => {

          if (data1.status == 'SUCCESS') {
            if (data1.cashAccounts.length) {
              this.isTableEmpty = false;
            } else {
              this.isTableEmpty = true;
            }

            this.customerDetails = data1;

            if(data1.cashAccounts.length==0){
              this.isNoCashAccounts=true;
            }
            data1.cashAccounts.forEach((cashAccount: { securityAccounts: any[]; }) => {
              if (cashAccount.securityAccounts && cashAccount.securityAccounts.length>0) {
                this.securityAccCount += cashAccount.securityAccounts.length;

                cashAccount.securityAccounts.forEach(securityAccount => {
                  if (securityAccount.exchangeAccounts && securityAccount.exchangeAccounts.length>0) {
                    this.exchangeAccCount += securityAccount.exchangeAccounts.length;
                  }
                });
              }

            });

            if(this.securityAccCount == 0){
              this.isNoSecurityAccounts=true;
            }

            if(this.exchangeAccCount == 0){
              this.isNoExchangeAccounts=true;
            }

          } else {
            //  this.isTableEmpty = true;
            this.isNoCashAccounts = true;
            this.isNoSecurityAccounts= true;
            this.isNoExchangeAccounts = true;
          }
        });
    } else {
      //this.isTableEmpty = true;
      this.isNoCashAccounts = true;
      this.isNoSecurityAccounts= true;
      this.isNoExchangeAccounts = true;
    }
    this.loadingExchanges = true;
    this.userService.getInstExchangesList(this.code, 'mena').subscribe((dataE: any) => {
      this.loadingExchanges = false;
      this.isTableEmptyExchange = false;

      if (dataE.status == 'SUCCESS') {
        this.Exchanges = dataE;

        if (
          this.Exchanges.list == null ||
          this.Exchanges.list == ''
        ) {
          this.isTableEmptyExchange = true;
        }
      } else {
        this.isTableEmptyExchange = true;
      }
    });


    this.loadingBankAcc = true;
    this.userService.getBankAccountDetails(this.code , "", 'mena').subscribe((data2: any) => {
      this.loadingBankAcc = false;
      this.isTableEmptyBankAcc = false;

      if (data2.status == 'SUCCESS') {
        this.bankDetails = data2;

        if (
          this.bankDetails.bankAccountList == null ||
          this.bankDetails.bankAccountList == ''
        ) {
          this.isTableEmptyBankAcc = true;
        }
      } else {
        this.isTableEmptyBankAcc = true;
      }
    });


    this.loadingBank = true;
    this.userService.getInstBankList(this.code, 'mena').subscribe((data3: any) => {
      this.loadingBank = false;
      this.isTableEmptyBank = false;

      if (data3.status == 'SUCCESS') {
        this.instBankList = data3;

        if (
          this.instBankList.bankList == null ||
          this.instBankList.bankList == ''
        ) {
          this.isTableEmptyBank = true;
        }
      } else {
        this.isTableEmptyBank = true;
      }
    });

    this.userService.getInstCustomerProfile(this.code, 'mena').subscribe((data4: any) => {
      console.log('Received data:', data4);
      this.isTableEmptyProfile = false;

      if (data4.status == 'SUCCESS') {
        this.instCustomerProfile = data4;

        if (
          this.instCustomerProfile.profileList == null ||
          this.instCustomerProfile.profileList.length == 0
        ) {
          this.isTableEmptyProfile = true;
        }

        this.instCustomerProfile.profileList.forEach((element: any)=>{
          if(element.isDefault==="YES"){
            this.defaultCustProfilesCount+=1;
          }
        })

        if(this.defaultCustProfilesCount==0){
          this.noDefaultCustProfiles=true;
        }

      } else {
        this.isTableEmptyProfile = true;
      }
    });

    this.userService.getInstSubscriptionPackageList(this.code, 'mena').subscribe((data5: any) => {
      this.isTableEmptyPackage = false;

      if (data5.status == 'SUCCESS') {
        this.instSubscriptionPackages = data5;

        if (
          this.instSubscriptionPackages.packageList == null ||
          this.instSubscriptionPackages.packageList.length == 0
        ) {
          this.isTableEmptyPackage = true;
        }

        this.instSubscriptionPackages.packageList.forEach((element: any)=>{
          if(element.isDefault=="YES"){
            this.defaultSubsPckgCount+=1;
          }
        })
        if(this.defaultSubsPckgCount==0){
          this.noDefaultSubsPckgs=true;
        }

      } else {
        this.isTableEmptyPackage = true;
      }
    });

  }


  selectedRowCP($event:any, customerNumber:any, userInded: number, customerName:any){
    if(userInded === this.selectedUserIndex) {
      this.selectedUserIndex = -1;
      return;
    }
    this.customerName = customerName;
    this.selectedUserIndex = userInded;
    this.isSelectRowCP = true
    this.loadingCP = true;

    this.userService
      .getCustomerDetails(customerNumber, 'mena')
      .subscribe((data1: any) => {

        this.loadingCP = false;
        if (data1.status == 'SUCCESS') {
          if (data1.cashAccounts.length) {
            this.isTableEmptyCP = false;
          } else {
            this.isTableEmptyCP = true;
          }
          this.customerDetailsCP = data1;
        } else {
          this.isTableEmptyCP = true;
        }
      });

  }

  selectedRowSP($event:any, subsPackages:any, userIndedSP: number){
    if(userIndedSP === this.selectedUserIndexSP) {
      this.selectedUserIndexSP = -1;
      return;
    }
    this.packageName = subsPackages.packageName;
    this.selectedUserIndexSP = userIndedSP;
    this.subsPackages = subsPackages;
    this.isSelectRowSP = true

    if(subsPackages.exchangeList.length)
    {
      this.isTableEmpty = false;
    }else{
      this.isTableEmpty = true;
    }


  }





  initializeForm(): void {

    this.form = this.formBuilder.group({
      publicKey: [this.publicKey ? this.publicKey : "-", [Validators.required]],
      appKey: [this.appKey ? this.appKey : "-", [Validators.required]],
      appSecret: [this.appSecret ? "***********" : "-", [Validators.required]],
      openApiEnabled: [this.openApiEnabled, [Validators.required]],
      fixEnabled: [this.fixEnabled, [Validators.required]],
      boApisEnabled: [this.boApisEnabled, [Validators.required]],
      dwmApiEnabled: [this.dwmApiEnabled, [Validators.required]],
      depositAutoApproval: [this.depositAutoApproval, [Validators.required]],
      withdrawAutoApproval: [this.withdrawAutoApproval, [Validators.required]],
    });
  }

  get formControl(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  onButtonGroupClick($event: any) {
    let clickedElement = $event.target || $event.srcElement;


    if (clickedElement.nodeName === 'BUTTON') {
      let isCertainButtonAlreadyActive =
        clickedElement.parentElement.querySelector('.active');
      // if a Button already has Class: .active
      if (isCertainButtonAlreadyActive) {
        isCertainButtonAlreadyActive.classList.remove('active');
      }
      this.topic = $event.target.role;

      if ($event.target.id == 'general') {
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.key-container-content'))).className += ' active';
        (<HTMLElement>(document.querySelector('.key-container-content'))).className += ' show';
      } else if ($event.target.id == 'masterAcc') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.masterAcc-content')).className +=' active';
        (<HTMLElement>document.querySelector('.masterAcc-content')).className +=' show';
      } else if ($event.target.id == 'bankAcc') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.bankAcc-content')).className +=' active';
        (<HTMLElement>document.querySelector('.bankAcc-content')).className +=' show';
      } else if ($event.target.id == 'banks') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.bank-content')).className +=' active';
        (<HTMLElement>document.querySelector('.bank-content')).className +=' show';
      } else if ($event.target.id == 'customer') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.customer-content')).className +=' active';
        (<HTMLElement>document.querySelector('.customer-content')).className +=' show';
      } else if ($event.target.id == 'subscription') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.subscription-content')).className +=' active';
        (<HTMLElement>document.querySelector('.subscription-content')).className +=' show';
      }else if ($event.target.id == 'exchanges') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.exchange-content')).className +=' active';
        (<HTMLElement>document.querySelector('.exchange-content')).className +=' show';
      }

      clickedElement.className += ' active';
    }
  }


  closeModal(): void {
    this.modalRef.close();
  }
}

